<div class="contents-area" (dragstart)="onDragstartBody($event)" style="width: calc(100vw - 300px);">
  <div class="block-column">
    <div class="block-row">
      <div class="column-list">
        <label class="list-input-title">受注コード</label>
        <div class="list-input-content">
          <input type="text" id="lbl_orderCode" class="deliv-catalog"
            #lbl_orderCode value="{{kymw9100Model.orderCode}}" readonly>
        </div>
        <label class="list-input-title">配達企画回(翌週)</label>
        <div class="list-input-content">
          <input type="text" id="lbl_nextCatalogID" class="deliv-catalog"
            #lbl_nextCatalogID value="{{kymw9100Model.catalogID}}" readonly>
        </div>
        <label class="list-input-title">Ｐコード</label>
        <div class="list-input-content">
          <input type="text" id="lbl_pcode" class="pcode" #lbl_pcode value="{{kymw9100Model.pcode}}" readonly>
        </div>
        <button class="btn-secondary" id="btn_search" #btn_search forcedEnabledMode="true" [tabindex]="0"
          (click)="searchBtnClicked()">検索</button>
      </div>
    </div>

    <div>
      <div class="action-area">
        <app-pager [prevDisabled]="kymw9100Model.prevDisabled" [nextDisabled]="kymw9100Model.nextDisabled"
          [totalNum]="kymw9100Model.totalNum" [startNum]="kymw9100Model.rowCntFrom" [endNum]="kymw9100Model.rowCntTo"
          (prevHandler)="prevBtnClicked(null)" (nextHandler)="nextBtnClicked(null)">
        </app-pager>
      </div>

      <wj-flex-grid [style.width.%]="100" [style.height.px]="622" id="dg_logList" #dg_logList
        [itemsSource]="kymw9100Model.accessLogList" [isReadOnly]="true" [allowSorting]="false" [allowDragging]="'None'"
        resizableColumns="true" (click)="eventDgLogList_HEADERRELEASEHandler($event,dg_logList)" [tabindex]="0">
        <wj-flex-grid-column [minWidth]="5" [header]="'受注コード'" sortable="false" [binding]="'OrderCode'" [width]="80">
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'Ｐコード'" sortable="true" [binding]="'PCode'" [width]="85">
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'アイテムコード'" sortable="true" [binding]="'ItemCode'" [width]="120">
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'会員生協'" sortable="true" [binding]="'CoopCode'" [width]="100">
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'処理種別'" sortable="false" [binding]="'ProcessKind'" [width]="100">
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'テーブルＩＤ'" sortable="false" [binding]="'TableID'" [width]="160">
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'項目ＩＤ'" sortable="false" [binding]="'ColumnID'" [width]="240">
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'OldValue'" sortable="false" [binding]="'OldValue'" [width]="100">
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'NewValue'" sortable="false" [binding]="'NewValue'" [width]="100">
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'更新日時'" sortable="true" [binding]="'UpdateDate'" [width]="200">
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ユーザーＩＤ'" sortable="true" [binding]="'UserID'" [width]="120">
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'アプリケーションＩＤ'" sortable="false" [binding]="'FuncID'" [width]="196">
        </wj-flex-grid-column>
      </wj-flex-grid>
    </div>
  </div>
</div>

<footer class="footer-buttons">
  <button class="btn-primary" id="btn_printOut" #btn_printOut [disabled]="kymw9100Model.printOutDisabled"
    (click)="printOutBtnClicked(null)" forcedEnabledMode="true" [tabindex]="0">出力</button>
</footer>